import React, { useCallback, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import debounce from 'lodash.debounce';
import { useHistory } from 'react-router-dom';

import Global from '../../store/global-selectors';
import { ColumnOrderByParamService } from '../../services/column-orderby-param-service';

import { setIsLoading, orderGridChangePage } from '../../store/orders/grid/orders.grid.actions';

import { getOrdersSuccess, getOrdersFailure } from '../../store/orders/orders.actions';
import { clearSearchInput } from '../../store/orders/nav/orders.nav.actions';

import { useIsOnOrdersAdvancedSearchView } from '../hooks';

import OrdersAdvancedSearchContainer from './container';
import { ADVANCED_SEARCH_ID } from '../../pages/orders-page/orders-page-view-constants';

const OrdersAdvancedSearchReduxContainer = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const isOnAdvancedSearch = useIsOnOrdersAdvancedSearchView();
  const { filterViewId } = useSelector(Global.selectOrdersFilteringActiveFilterView);
  const orderBy = useSelector((state) =>
    Global.selectOrdersGridCurrentOrderByColumn(state, {
      statusViewId: ADVANCED_SEARCH_ID,
      activeFilterViewId: filterViewId,
    }),
  );
  const orderByParam = ColumnOrderByParamService.getOrdersGridOrderByApiParameterOrDefault(orderBy, true);

  const switchToAdvancedSearchView = useCallback(
    ({ clearRouteState = false } = {}) => {
      if (!isOnAdvancedSearch) {
        dispatch(clearSearchInput());
        if (clearRouteState) {
          history.replace(`/orders/${ADVANCED_SEARCH_ID}`, null);
        } else {
          history.push(`/orders/${ADVANCED_SEARCH_ID}`);
        }
        dispatch(orderGridChangePage(1));
        return;
      }
      if (clearRouteState) {
        history.replace(history.location.pathname + history.location.search, null);
      }
      dispatch(setIsLoading(true));
    },
    [dispatch, history, isOnAdvancedSearch],
  );

  const onSubmit = useMemo(
    () =>
      debounce((makeApiCall, page, pageSize) => {
        makeApiCall(page, pageSize)
          .then(({ page: responsePage, pageSize: responsePageSize, totalCount, currentPageFulfillmentPlanIds }) => {
            dispatch(getOrdersSuccess(currentPageFulfillmentPlanIds, responsePage, responsePageSize, totalCount));
          })
          .catch(() => dispatch(getOrdersFailure()));
      }),
    [dispatch],
  );

  return (
    <OrdersAdvancedSearchContainer
      onSubmit={onSubmit}
      orderBy={orderByParam.orderBy}
      orderByDirection={orderByParam.orderByDirection}
      switchToAdvancedSearchView={switchToAdvancedSearchView}
    />
  );
};

export default OrdersAdvancedSearchReduxContainer;
